import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export abstract class GenericService {

  url_base: String = environment.urlBase;

  header_required: boolean = true;

  protected prefixo: any;

  constructor(protected http: HttpClient, protected target: any) {
    this.prefixo = target;
  }



  index(page = null): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}`;

    if (page !== null) {
      url += '?page=' + page;
    }

    return this.http.get(url);
  }

  show(id: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/${id}`);
  }

  store(params: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}`, params);
  }

  update(params: any, id: number): Observable<any> {
    return this.http.put(`${this.url_base}/${this.prefixo}/${id}`, params);
  }

  destroy(id: number): Observable<any> {
    return this.http.delete(`${this.url_base}/${this.prefixo}/${id}`);
  }

  getCep(cep: any): Observable<any> {
    return this.http.get(`${this.url_base}/get/cep/${cep}`);
  }

  save(params = null, id = null) {
    if (id != null) {
      return this.http.put(`${this.url_base}/${this.prefixo}/${id}`, params);
    } else {
      return this.http.post(`${this.url_base}/${this.prefixo}`, params);
    }
  }

}
